import { createRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoginAction } from './use-Login';
import styles from './style.module.css';
import { LocalData } from "../../service/localStorage";
import { changeDirection, faviconUpdate } from '../../utils';
import { Set_AccessToken } from "../../Redux/actions/actionNames";
import { Helmet } from "react-helmet";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from 'react-i18next';
import CircularProgress from "@material-ui/core/CircularProgress";
import { snack } from '../../utils/SnackbarUtilsConfigurator';
import { LoginApi } from '../../service/API';
import ProgressBar from '../../design-system/lib/ProgressBar';
import { RefreshTokenCheck } from '../../helper/api';
import { get_accessToken, get_adminToken, get_refreshToken, get_settings_dispatcher } from '../../helper/UserData/userdate';
import {  Redirect } from "react-router-dom";
import { useQuery } from '../../hooks/useQuery';
import { DispatcherApi } from '../../service/API/dispatcher';
import history from '../../service/history';
import { isEmpty } from 'lodash';

export const Login = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const localData = new LocalData();
    const [username, setUsername] = useState(localData.get('username') || "");
    const [password, setPassword] = useState(localData.get('password') || "");
    const [istokenCheck, setIstokenCheck] = useState(true);
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const authenticated = useSelector((state) => state.LocalData.access_token);
    const searchParams = useQuery();
    const tokenCheck = searchParams.get("redirect");
    const [gettingStarted, setGettingStarted] = useState(false);

    useEffect(()=>{
        if (username.length > 0 && password.length > 0) {
            setCanSend(true);
        } else {
            setCanSend(false);
        }
    }, [username, password])


    useEffect(() => {
        if (tokenCheck) {
            setIstokenCheck(true);
            // setFrom(window.location.pathname.replace('/login/redirect=', ''))
            setTo(`${window.location.origin}${tokenCheck}`)

            if (get_refreshToken() && String(get_refreshToken()).length > 10) {
                RefreshTokenCheck(() => {
                    window.location.replace(`${window.location.origin}${tokenCheck}`);
                })
            } else {
                setIstokenCheck(false);
            }


        } else {
            setIstokenCheck(false);
        }
    }, [tokenCheck])

    const [loading, setLoading] = useState(false);
    const [canSend, setCanSend] = useState(username && password ? true : false);

    useEffect(() => {
        faviconUpdate();
        changeDirection();
    }, [])

    const passwordInput = createRef();
    const LoginBtn = createRef();


    const usernameOnKeyUp = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            if (username.length > 2) {
                passwordInput.current.focus();
            }
        }
    }

    const passwordOnKeyUp = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            if (password.length > 2) {
                LoginBtn.current.click();
            }
        }
    }

    const LoginClick = async () => {

        if (canSend && !loading) {
            setLoading(true);

            try {
                const result = await LoginAction({ username, password });
                if (result) {
                    const Dispatcher = new DispatcherApi();
                    const data = await Dispatcher.Setting({ userId: result.userId, refreshToken: result.refreshToken , adminToken : result.adminToken} );

                    if (data) {
                        if (!data.onboardingStatus.getStartCompleted) {
                            setGettingStarted(true)
                        }
                        dispatch(Set_AccessToken(result.accessToken));
                        if (tokenCheck) {
                            const loginApi = new LoginApi();
                            const Dashboardlogin = await loginApi.Dashboardlogin(result.adminToken);
                            window.location.replace(to);
                        } 


                    }

                }

            } catch (error) {
                if (error?.code === -400) {
                    snack.warning_i18(error.message)

                } else if (error?.code === -1) {
                    snack.warning_i18("enterDataCorrectly")
                } else {

                   setTimeout(async () =>  {
                     if(!isEmpty(get_settings_dispatcher())){
                        if (!get_settings_dispatcher().onboardingStatus.getStartCompleted) {
                            setGettingStarted(true)
                        }
                        dispatch(Set_AccessToken(get_accessToken()));
                        if (tokenCheck) {
                            const loginApi = new LoginApi();
                            const Dashboardlogin = await loginApi.Dashboardlogin(get_adminToken());
                            window.location.replace(to);
                        } 

                     }
                   }, 600);

                }
            }

            setLoading(false);


        } else {
            snack.warning_i18("enterDataCorrectly")
        }
    };

    
     if (isLogin() && !tokenCheck && authenticated && gettingStarted) {
         return <Redirect
             to={"/gettingstarted"}
         />
      }

     if (isLogin() && !tokenCheck && authenticated && !gettingStarted) {
          return <Redirect
              to={"/"}
         />
     }
    return <>

        <Helmet>
            <title> {global.config.dispatcherText.title}</title>
            <style type="text/css">{`
           body .changingCssAnimationxx { 
 
      background-color: transparent;

         display: none !important;
         z-index: -1;
}
         `}</style>

        </Helmet>
        <Paper
            style={{
                width: "348px",
                height: "313px",
                position: "absolute",
                top: "26%",
                float: "right",
                right: "calc(50% - 174px)",
                borderRadius: "8px",
            }}
            elevation={3}
        >
            <img
                className={styles.LogoType}
                src={global.config.logoTypeUrl}
                alt=":"
            />
            <span
                className={styles.enterData}
            >
                {t("Enter_the_following_information_to_enter")}
            </span>

            <input

                value={username}
                onKeyUp={usernameOnKeyUp}
                className={styles.username}
                onChange={e=> setUsername(e.target.value)}
                placeholder={t("username")}
            />
            <input
                type="password"
                ref={passwordInput}
                value={password}
                onKeyUp={passwordOnKeyUp}
                className={styles.password}
                onChange={e => setPassword(e.target.value)}
                placeholder={t("password")}
            />

            <span
                onClick={LoginClick}
                ref={LoginBtn}
                className={styles.loginBtn}
                style={{
                    backgroundColor: canSend && !loading
                        ? "#148be9"
                        : "rgba(128, 128, 128, 0.4)",
                }}
            >
                {loading ? (
                    <CircularProgress
                        size={18}
                        style={{
                            color: "white",
                            float: "right",
                            marginRight: "140px",
                            marginTop: "5px",
                        }}
                    />
                ) : (

                    t("login")
                )}
            </span>
        </Paper>
    </>

};


function isLogin () {
    if (String(window.location.href).includes("login")) {
      return true
    } else {
      return false
    }
  }
  


